import { EndpointsName } from './../../Auth/authTypes';
import { Observable } from "rxjs";
import { share, catchError, map, finalize } from "rxjs/operators";
import { ALCConfigParamsDataWithType, ALCConfigParamsGroupData, IsParameterEnableData, ProcessType } from "../../types";
import { get, put } from '../../Auth';
import { default as lodashMerge } from 'lodash/merge';
import { withLogger } from '../LogerServices';

// TODO: Until there is no endpoint returning global config factory data
const Config = {
  getARCConfig: null as Observable<ALCConfigParamsGroupData[]>,
  getCDSConfig: null as Observable<ALCConfigParamsGroupData[]>,
  getADCConfig: null as Observable<ALCConfigParamsGroupData[]>
}

// CONFIG
const getConfiData = (process: ProcessType) => {
  Config[`get${process}Config`] = withLogger(get<ALCConfigParamsGroupData>(EndpointsName.CONFIG, `/${process}`), ProcessType.CONFIG, { isInitial: true, optionalText: process }).pipe(
    map(data => lodashMerge([], data), []),
    finalize(() => Config[`get${process}Config`] = null),
    share(),
    catchError((err) => { throw err })
  );
  return Config[`get${process}Config`];
};

//TO verify
// export const getConfigDataObserver = (process: ProcessType): Observable<ALCConfigParamsGroupData[]> => get<ALCConfigParamsGroupData[]>(EndpointsName.CONFIG, `/${process}`)
export const getConfigDataObserver = (process: ProcessType): Observable<ALCConfigParamsGroupData[]> => Config[`get${process}Config`] ? Config[`get${process}Config`] : getConfiData(process);
export const putConfigData = (process: ProcessType, parameter: ALCConfigParamsDataWithType) => put(EndpointsName.CONFIG, `/${process}/parameter`, parameter);

// ENABLE
export const getIsEnableConfigData = (process: ProcessType) => get<IsParameterEnableData[]>(EndpointsName.CONFIG, `/${process}/enable`);
export const putIsEnableConfigData = (process: ProcessType, parameter: IsParameterEnableData) => put(EndpointsName.CONFIG, `/${process}/parameter/enable`, parameter);
